// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateCustomerRequest } from '../models';
import { CreateCustomerResponse } from '../models';
import { CustomerNotificationsItemResponse } from '../models';
import { UpdateCustomerNotificationsRequest } from '../models';
/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsGet(options: any = {}): RequestArgs {
      const localVarPath = `/customer/notifications`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateCustomerNotificationsRequest} updateCustomerNotificationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsPut(
      updateCustomerNotificationsRequest: UpdateCustomerNotificationsRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'updateCustomerNotificationsRequest' is not null or undefined
      if (
        updateCustomerNotificationsRequest === null ||
        updateCustomerNotificationsRequest === undefined
      ) {
        throw new RequiredError(
          'updateCustomerNotificationsRequest',
          'Required parameter updateCustomerNotificationsRequest was null or undefined when calling customerNotificationsPut.'
        );
      }
      const localVarPath = `/customer/notifications`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof updateCustomerNotificationsRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            updateCustomerNotificationsRequest !== undefined
              ? updateCustomerNotificationsRequest
              : {}
          )
        : updateCustomerNotificationsRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateCustomerRequest} [createCustomerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPost(createCustomerRequest?: CreateCustomerRequest, options: any = {}): RequestArgs {
      const localVarPath = `/customer`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof createCustomerRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createCustomerRequest !== undefined ? createCustomerRequest : {})
        : createCustomerRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsGet(
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<CustomerNotificationsItemResponse> {
      const localVarAxiosArgs = CustomerApiAxiosParamCreator(
        configuration
      ).customerNotificationsGet(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {UpdateCustomerNotificationsRequest} updateCustomerNotificationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsPut(
      updateCustomerNotificationsRequest: UpdateCustomerNotificationsRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<CustomerNotificationsItemResponse> {
      const localVarAxiosArgs = CustomerApiAxiosParamCreator(
        configuration
      ).customerNotificationsPut(updateCustomerNotificationsRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateCustomerRequest} [createCustomerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPost(
      createCustomerRequest?: CreateCustomerRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCustomerResponse> {
      const localVarAxiosArgs = CustomerApiAxiosParamCreator(configuration).customerPost(
        createCustomerRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsGet(options?: any): AxiosPromise<CustomerNotificationsItemResponse> {
      return CustomerApiFp(configuration).customerNotificationsGet(options)(axios, basePath);
    },
    /**
     *
     * @param {UpdateCustomerNotificationsRequest} updateCustomerNotificationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerNotificationsPut(
      updateCustomerNotificationsRequest: UpdateCustomerNotificationsRequest,
      options?: any
    ): AxiosPromise<CustomerNotificationsItemResponse> {
      return CustomerApiFp(configuration).customerNotificationsPut(
        updateCustomerNotificationsRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {CreateCustomerRequest} [createCustomerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customerPost(
      createCustomerRequest?: CreateCustomerRequest,
      options?: any
    ): AxiosPromise<CreateCustomerResponse> {
      return CustomerApiFp(configuration).customerPost(createCustomerRequest, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */
  public customerNotificationsGet(options?: any) {
    return CustomerApiFp(this.configuration).customerNotificationsGet(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   *
   * @param {UpdateCustomerNotificationsRequest} updateCustomerNotificationsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */
  public customerNotificationsPut(
    updateCustomerNotificationsRequest: UpdateCustomerNotificationsRequest,
    options?: any
  ) {
    return CustomerApiFp(this.configuration).customerNotificationsPut(
      updateCustomerNotificationsRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {CreateCustomerRequest} [createCustomerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */
  public customerPost(createCustomerRequest?: CreateCustomerRequest, options?: any) {
    return CustomerApiFp(this.configuration).customerPost(createCustomerRequest, options)(
      this.axios,
      this.basePath
    );
  }
}
